import { IconButton } from "@altimateai/lego";
import { CheckNoOutlineIcon } from "../../../../assets/icons";
import classes from "../../details/styles.module.scss";
import { useState } from "react";
import { resolveConversationGroup as resolveConversationGroupApi } from "../../api";
import { DbtDocsShareDetails } from "../types";
import { ConversationGroup } from "./context/types";
import { useConversationGroupContext } from "./context/ConversationsProvider";

const ResolveButton = ({
  conversationGroupId,
  shareId,
}: {
  conversationGroupId?: ConversationGroup["conversation_group_id"];
  shareId: DbtDocsShareDetails["share_id"];
}) => {
  const { onResolve, source } = useConversationGroupContext();
  const [loading, setLoading] = useState(false);
  const handleClick = async () => {
    if (!conversationGroupId) {
      return;
    }
    setLoading(true);
    await resolveConversationGroupApi(shareId, conversationGroupId, source);
    onResolve();
    setLoading(false);
  };
  if (!conversationGroupId) {
    return null;
  }
  return (
    <IconButton
      disabled={loading}
      className={classes.resolveButton}
      title="Resolve conversation"
      onClick={handleClick}
    >
      <CheckNoOutlineIcon />
    </IconButton>
  );
};

export default ResolveButton;
